import { jsx as _jsx } from "react/jsx-runtime";
import { TransportProvider } from '@connectrpc/connect-query';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import { transport } from './utils/transport';
import './styles/main.css';
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5,
            retry: 1
        }
    }
});
const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Failed to find the root element');
}
ReactDOM.createRoot(rootElement).render(/*#__PURE__*/ _jsx(React.StrictMode, {
    children: /*#__PURE__*/ _jsx(TransportProvider, {
        transport: transport,
        children: /*#__PURE__*/ _jsx(QueryClientProvider, {
            client: queryClient,
            children: /*#__PURE__*/ _jsx(HelmetProvider, {
                children: /*#__PURE__*/ _jsx(RouterProvider, {
                    router: router
                })
            })
        })
    })
}));
